<template>
  <button
    type="button"
    class="inline-flex items-center text-center p-2 m-2 bg-navbg-dark leading-tight rounded shadow-md focus:shadow-lg"
  >
    <slot class="ml-1">Send</slot>
  </button>
</template>
